module.exports = __webpack_public_path__ + "img/undraw_candidate_ubwv.6d5f57e9.svg";